<template>
	<wt-selector :options="options" v-model="Value"></wt-selector>
</template>
<script>
import { ConfigType } from 'json/lab-order'
export default {
  name: 'order-sampleType-selector',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Value: this.value,
      options: this.change(ConfigType)
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    change (arr) {
      var newArr = []
      arr.forEach(ele => {
        var obj = {}
        obj.value = ele.key
        obj.label = ele.value
        newArr.push(obj)
      })
      return newArr
    }
  },
  created () {
  }
}
</script>
